import React from "react";
import { Doughnut } from "react-chartjs-2";

const DoughnutChart = ({ data, options, plugins }) => {
  return (
    <Doughnut
      data={data}
      plugins={plugins}
      options={{
        maintainAspectRatio: false,
        ...options,
      }}
    />
  );
};

export default DoughnutChart;
